module.exports = __webpack_public_path__ + "static/hunanmountains-8a916d6d7fa4432fb564861c0cad11f7.webp";